
<template>
  <page-layout
    :breadcrumbs="breadcrumbs"
    :title="$t('pages.configuracion.configuracion')"
  >
    <v-layout row justify-center>
      <v-flex xl8>
        <v-container grid-list-xl mt-3 pa-0>
          <v-layout row wrap justify-center>
            <v-flex
              xs12 sm8 md6 xl5
              v-for="accion in acciones"
              :key="accion.titulo"
              d-flex
            >
              <v-card class="pointer" @click="$router.push({name: accion.ruta})">
                <o-tint-img :src="accion.src"/>
                <v-card-title class="pb-0">
                    <v-icon
                      left
                      color="primary"
                      class="custom-icon"
                    >
                      {{accion.icon}}
                    </v-icon>
                  <h3 class="primary--text headline">{{accion.titulo}}</h3>
                </v-card-title>
                <v-card-text>
                  <span class="grey--text">{{accion.desc}}</span>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </page-layout>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  computed: {
    breadcrumbs () {
      return [
        {
          text: this.$t('pages.home'),
          exact: true,
          to: {name: 'home'}
        },
        {
          text: this.$t('pages.configuracion.configuracion'),
          disabled: true
        }
      ]
    },
    acciones () {
      return [
        {
          titulo: this.$t('pages.configuracion.general'),
          desc: this.$t('pages.configuracion.gestionaGeneral'),
          ruta: 'configuracion.general',
          src: require('@/assets/images/config/config_general.jpg'),
          icon: 'icon-settings'
        },
        {
          titulo: this.$t('reservaSimplificada.titulo'),
          desc: this.$t('reservaSimplificada.texto'),
          ruta: 'configuracion.promociones',
          src: require('@/assets/images/config/config_promo.jpg'),
          icon: 'icon-settings'
        },
        {
          titulo: this.$t('pages.configuracion.textos'),
          desc: this.$t('pages.configuracion.gestionaTextos'),
          ruta: 'configuracion.textos',
          src: require('@/assets/images/config/config_textos.jpg'),
          icon: 'mdi-note-text'
        },
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/configuracion/configuracion.vue